<template>
   <section class="bg-gray-50 py-16 md:py-24" id="partners">
      <div class="container mx-auto px-6">
        <div class="text-center mb-16">
          <h2 class="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            合作伙伴
          </h2>
          <div class="w-20 h-1 bg-blue-700 mx-auto mb-6"></div>
          <p class="text-gray-700 max-w-3xl mx-auto">
            我们与众多行业领先企业建立了长期稳定的合作关系，共同推动技术创新和行业发展。
          </p>
        </div>
     
       
       <div
          class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 items-center"
        >
            <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-microsoft text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c1.png"
          /></span>
        </div>
        <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-amazon text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c2.png"
          /></span>
        </div>
        <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-amazon text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c3.png"
          /></span>
        </div>
        <div
          class="height140 flex flex-col items-center justify-center p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
        >
          <i class="fab fa-amazon text-5xl text-blue-700 mb-3"></i>
          <span class="text-gray-800 font-medium"
            ><img src="../assets/c4.png"
          /></span>
        </div>
          
        </div>
       </div>  
    </section>
</template>

<script>
export default {
  name: "PartnerPage",
};
</script>
<style scoped>
.height140 {
  height: 140px;
}
</style>
